import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block relative rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
    >
      <div className={`relative ${isLarge ? 'aspect-[2/3]' : 'aspect-[2/3]'} overflow-hidden rounded-lg`}>
        <img
          src={movie.poster}
          alt={movie.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          title={`${movie.title} - 星空影院在线观看免费`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-300"></div>

        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {movie.isHot && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
              热门
            </span>
          )}
          {movie.isNew && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-950 whitespace-nowrap">
              最新
            </span>
          )}
        </div>

        <div className="absolute top-3 right-3">
          <span className="px-2 py-0.5 rounded-md text-xs font-semibold bg-background-950/70 text-primary-500 whitespace-nowrap backdrop-blur-sm">
            {movie.rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-4">
          <div className="flex items-center gap-1.5 mb-1.5">
            {movie.type === 'series' && (
              <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-secondary-500/80 text-background-50 whitespace-nowrap">
                剧集
              </span>
            )}
            <span className="text-[11px] text-foreground-400">{movie.year}</span>
            {movie.type === 'series' && movie.episodeInfo && (
              <span className="text-[11px] text-foreground-500">· {movie.episodeInfo}</span>
            )}
          </div>
          <h3 className={`font-heading font-semibold text-foreground-50 leading-tight ${isLarge ? 'text-base md:text-lg' : 'text-sm md:text-base'}`}>
            {movie.title}
          </h3>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 backdrop-blur-sm shadow-lg shadow-primary-500/30 transform group-hover:scale-110 transition-transform duration-300">
            <i className="ri-play-fill text-background-950 text-xl md:text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}